import { Adapter as r } from "../../../adapter.js";
import { TicketCashbackModel as t } from "./ticketCashback.model.js";
class i extends r {
  adapt(e) {
    return new t({
      earned: e.earned ?? 0,
      paid: e.paid ?? 0
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  i as TicketCashbackAdapter
};
//# sourceMappingURL=ticketCashback.adapter.js.map
